export default __webpack_public_path__ + "static/media/scatter-plot-approval-and-completion.a1760275.svg";